
import Vue from "vue";

export default Vue.extend({
  name: "component-maps-footer",
  props: {
    showCopyright: {
      type: Boolean,
      default: true,
    },
    onMenu: {
      type: Boolean,
      default: false,
    },
  },
});
